import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {InternalBlindSimpleSelectService} from "./internalBlindSimpleSelectService";

export class InternalBlindSimpleSelectUIService {
    private uiService: UIService;
    private productDataService: ProductDataService;
    private productDataStore: ProductDataStore;
    private simpleBlindService: InternalBlindSimpleSelectService;

    constructor() {
        this.uiService = new UIService();
        this.productDataService = new ProductDataService();
        this.productDataStore = new ProductDataStore();
        this.simpleBlindService = new InternalBlindSimpleSelectService();
    }

    public initializeInternalBlindControlSideSelector() {
        let internalBlindControlSides = this.productDataStore.getAvailableOptionsByName('internalBlindControlSides');

        internalBlindControlSides.forEach(internalBlindControlSide => {
            const option = this.createInternalBlindControlSideOption(internalBlindControlSide);
            if (internalBlindControlSide.id === this.productDataStore.getSelectedOptionIdByName('internalBlindControlSide')) {
                this.uiService.setSelectedOption(option);
            }

            option.addEventListener('click', (event: any) => {
                this.productDataService.updateSelectedOptionByName('internalBlindControlSide', internalBlindControlSide.id, true);
                this.uiService.resetSelectionsByPartName('internalBlindControlSide');
                this.uiService.setSelectedOption(event.currentTarget);
            });
        });

        const resetButton = this.uiService.getResetButtonByModule('internalBlindControlSide');
        resetButton.addEventListener('click', this.simpleBlindService.resetInternalBlindControlSide);
    }

    public initializeInternalBlindBottomRailSelector() {
        let internalBlindBottomRails = this.productDataStore.getAvailableOptionsByName('internalBlindBottomRails');

        internalBlindBottomRails.forEach(internalBlindBottomRail => {
            const option = this.createInternalBlindBottomRailsOption(internalBlindBottomRail);
            if (internalBlindBottomRail.id === this.productDataStore.getSelectedOptionIdByName('internalBlindBottomRail')) {
                this.uiService.setSelectedOption(option);
            }

            option.addEventListener('click', (event: any) => {
                this.productDataService.updateSelectedOptionByName('internalBlindBottomRail', internalBlindBottomRail.id, true);
                this.uiService.resetSelectionsByPartName('internalBlindBottomRail');
                this.uiService.setSelectedOption(event.currentTarget);
            });
        });

        const resetButton = this.uiService.getResetButtonByModule('internalBlindBottomRail');
        resetButton.addEventListener('click', this.simpleBlindService.resetInternalBlindBottomRail);
    }

    private createInternalBlindControlSideOption(controlSide) {
        const option = this.uiService.createConfiguratorOption('internalBlindControlSide');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            controlSide.id
        );

        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute('nf-value-key', 'img', option),
            'src',
            controlSide.attributes.imgSrc
        );

        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'name', option),
            controlSide.attributes.name
        );

        const price = '+' + ((controlSide.attributes.priceAfterDiscount) ?? 0) + ' kr';
        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'price', option),
            price
        );

        return option;
    }

    private createInternalBlindBottomRailsOption(bottomRail) {
        const option = this.uiService.createConfiguratorOption('internalBlindBottomRail');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            bottomRail.id
        );

        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute('nf-value-key', 'img', option),
            'src',
            bottomRail.attributes.imgSrc
        );

        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'name', option),
            bottomRail.attributes.name
        );

        const price = '+' + ((bottomRail.attributes.priceAfterDiscount) ?? 0) + ' kr';
        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'price', option),
            price);

        return option;
    }
}
